import { Buffer } from 'buffer';

(globalThis as typeof globalThis & { Buffer: typeof Buffer }).Buffer = Buffer;

import ReactDOM from 'react-dom/client';
import { Provider, MasterHook } from 'iomart-hooks';

import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { initReduxHook } from './hooks/useRedux';

// ----------------------------------------------------------------------

MasterHook(initReduxHook);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider>
    <App />
  </Provider>
);

if (window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone) {
  document.body.classList.add('pwa-standalone');
  if (/iphone|ipad|ipod/i.test(window.navigator.userAgent)) {
    document.body.classList.add('pwa-ios');
  }
  if (/android/i.test(window.navigator.userAgent)) {
    document.body.classList.add('pwa-android');
  }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
